export const PHONE = 'phone';
export const DESKTOP = 'desktop';

export const mediaQueries = {
  [PHONE]: '(max-width: 600px)',
  [DESKTOP]: '(min-width: 601px)'
};
